export default "__VITE_ASSET__DMr1qj67__"